import { Amplify } from 'aws-amplify';

const amplifyConfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'your_user_pool_id',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || 'your_client_id',
    }
  }
};

Amplify.configure(amplifyConfig);

export default amplifyConfig;
